import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { AlertCircleLine, Warning } from '@factorialco/f0-react/icons/app'

interface Props {
  title: string
  type: 'promote' | 'critical'
}

const Alert = ({ title, type }: Props) => {
  const background = type === 'critical' ? 'radicalRed100' : 'tangerine200'
  const icon = type === 'critical' ? AlertCircleLine : Warning
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      background={background}
      paddingY="s12"
      paddingX="s16"
      borderRadius={{ all: 'abs016' }}
      width="fit-content"
      gap="s8"
    >
      <F0Icon size="md" icon={icon} color={type} />
      <Text.Normal size="200" weight="normal" color="grey1000">
        {title}
      </Text.Normal>
    </Box>
  )
}

export default Alert
